<template lang="html">
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on }">
      <StandardEditBtn class="pull-right" :el="on" @editClick="editActivator()" />
    </template>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>TAKT.step Editor</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="10" align="center" justify="center">
            <v-alert type="info">
              All changes apply instantly and are saved immediately.
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
      <v-card
        class="mb-12 pa-2"
        color="color-3"
        min-height="200px"
      >
          <v-row>
            <v-col cols="12" class="ma-2 pa-2">
              <h2>Edit your TAKT.step</h2>
              <b>The TAKT.step</b>
              <StandardTextfield color="secondary" placeholder="Text"
                                 type="text" min="1" style="width: 50%"
                                 :value="work_step.text" @changeValue="updateWorkStepText($event)" />
             <div class="mt-5"></div>
              <b>Country</b>
              <StandardFlagDropdown
              :value="getCountryName(work_step.country)"
              color="secondary"
              :options="countries"
              @changeValue="updateWorkStepCountry($event)" />
              <div class="mt-5"></div>
              <b>Hashtags</b>
              <StandardTextfield color="secondary" placeholder="Hashtags"
              type="text" min="1" style="width: 50%"
              :value="getWorkStepHashtags" @changeValue="updateHashtags($event)" />
            </v-col>
          </v-row>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Done editing</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex';
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import StandardFlagDropdown from '@/components/StandardComponents/StandardFlagDropdown.component.vue'
import StandardEditBtn from '@/components/StandardComponents/StandardEditBtn.component.vue'

import {
  getCountries
} from '../../helpers/data';


export default {
  name: 'WorkStepEditorDialog',
  props: ['work_step'],
  components: {
    StandardTextfield,
    StandardFlagDropdown,
    StandardEditBtn
  },
  data: () => ({
    dialog: false,
    countries: []
  }),
  computed: {
    ...mapGetters('WorkStep', []),
    getWorkStepHashtags: function() {
      const hashtags = [];
      for (var i = 0; i < this.work_step.hashtags.length; i++) {
        hashtags.push(this.work_step.hashtags[i].tag);
      }
      return hashtags.join(' ');
    }
  },
  methods: {
    getCountryName(flag){
      const country = this.countries.find(c => c.flag === flag);
      if (country) {
        return country.name;
      }
      return 'n/a';
    },
    updateHashtags(hashtags) {
      let hashtag_arr = hashtags.split(' ');
      for (var i = 0; i < hashtag_arr.length; i++) {
        if (hashtag_arr[i].startsWith('#')) {
          hashtag_arr[i] = hashtag_arr[i].substr(1);
        }
      }
      this.updateWorkStepHashtags({
        work_step_id: this.work_step.id,
        update: {hashtags: hashtag_arr}
      });
    },
    editActivator() {
      this.countries = getCountries();
      this.countries.push({
        flag: 'other',
        name: 'Other'
      });
      this.dialog = true;
    },
    updateWorkStepText(text){
      this.updateWorkStep({
        work_step_id: this.work_step.id,
        update: {
          text: text
        }
      });
    },
    updateWorkStepCountry(country){
      this.updateWorkStep({
        work_step_id: this.work_step.id,
        update: {
          country: country.flag
        }
      });
    },
    ...mapActions('WorkStep', [
      'updateWorkStep',
      'updateWorkStepHashtags'
    ])
  }
}
</script>

<style lang="css" scoped>
.picker-card {
  width: 58px;
  height: 38px;
  float: left;
  margin: 5px;
  cursor: pointer;
}
</style>
